<template>
    <v-data-table
    :headers="headers"
    :items="listado"
    :items-per-page="20">
    <template v-slot:[`item.numero`]="{ item }">
      <router-link
        :to="{ name: 'consultasContratoDefault', params: { idContrato: item.id } }"
      >
        <strong>
          {{ item.numero }}
        </strong>
      </router-link>
    </template>
    <template v-slot:[`item.tipoDeObra`]="{ item }">
      <template
        v-if="item.obra">
        <v-chip
          small
          :color="item.obra.obra.tipo.color">
          {{ item.obra.obra.tipo.descripcion }}
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
        :texto="item.meta">
      </cortar-texto>
    </template>
    <template v-slot:[`item.fecha`]="{ item }">
      {{ $moment(item.fecha).format('DD/MM/YYYY')}}
    </template>
    <template v-slot:[`item.total`]="{ item }">
      <template
        v-if="item.modificado.total <= 0">
        {{ (item.total) | currency }}
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ (item.total + item.modificado.total) | currency }}
        </span>
      </template>
    </template>
    <!-- <template v-slot:[`item.totalAnticipo`]="{ item }">
      {{ item.totalAnticipo | currency }}
    </template>
    <template v-slot:[`item.supervisionExterna`]="{ item }">
      <template
        v-if="item.supervisionExterna">
        {{ item.supervisionExterna.contratoRelacionado.contratista.nombreRazonSocial }}
      </template>
    </template> -->
    <template v-slot:[`item.fechaInicio`]="{ item }">
      <template
        v-if="!item.modificado.fechaInicio">
        <span
          class="base1--text font-weight-medium">
          {{ $moment(item.fechaInicio).format('DD/MM/YYYY') }}
        </span>
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ $moment(item.modificado.fechaInicio).format('DD/MM/YYYY') }}
        </span>
      </template>
    </template>
    <template v-slot:[`item.fechaTermino`]="{ item }">
      <template
        v-if="!item.modificado.fechaTermino">
        <span
          class="base1--text font-weight-medium">
          {{ $moment(item.fechaTermino).format('DD/MM/YYYY') }}
        </span>
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ $moment(item.modificado.fechaTermino).format('DD/MM/YYYY') }}
        </span>
      </template>
    </template>
    <template v-slot:[`item.avanceProgramado`]="{ item }">
      <template
        v-if="item.avanceProgramado.porcentaje">
        <v-chip
          small
          color="naranja2">
          {{ item.avanceProgramado.porcentaje }}%
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.avanceFisico`]="{ item }">
      <template
        v-if="item.porcentajeAvanceFisico">
        <v-chip
          small
          color="azul1">
          {{ item.porcentajeAvanceFisico }}%
        </v-chip>
      </template>
      <template
        v-else>
        <v-chip
          small
          disabled>
          0
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.avanceFinanciero`]="{ item }">
      <template>
        <v-chip
          small
          color="verde1">
          {{ item.porcentajeAvanceFinanciero }}%
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.estatus`]="{ item }">
      <template
        v-if="item.ultimoReporte">
        <v-chip
          small
          :color="colorEstatus(item.ultimoReporte.avanceDiferencia)"
          :dark="colorEstatus(item.ultimoReporte.avanceDiferencia) === 'red darken-2'">
          <template
            v-if="item.ultimoReporte.avanceDiferencia < 0">
            {{ dosDigitos((item.ultimoReporte.avanceDiferencia * -1)) }}%
          </template>
          <template
            v-else>
            {{ dosDigitos(item.ultimoReporte.avanceDiferencia) }}%
          </template>
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.imagen`]="{ item }">
      <v-img
        class="my-2"
        v-if="getImagenAlbum(item.id)"
        :src="`${$urlFileServer}/${getImagenAlbum(item.id)}/thumbnail`"
        :lazy-src="`${$urlFileServer}/${getImagenAlbum(item.id)}/thumbnail`"
        height="50"
        width="50"
        contain>
      </v-img>
    </template>
  </v-data-table>
</template>

<script>
import CONTRATO_ACTIVIDADES_TODAS from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividadesTodas.gql';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'DesktopListadoReporteConsulta',
  components: {
    CortarTexto,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  apollo: {
    contratoActividadesTodas: {
      query: CONTRATO_ACTIVIDADES_TODAS,
    },
  },
  data() {
    return {
      headers: [
        {
          text: '', value: 'imagen', align: 'center', width: '50', sortable: true,
        },
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        { text: 'Tipo', value: 'tipoDeObra', sortable: false },
        { text: 'Objeto', value: 'meta', sortable: false },
        {
          text: 'Contratista', value: 'contratista.nombreRazonSocial', sortable: false,
        },
        {
          text: 'Fecha', value: 'fecha', align: 'center', sortable: false,
        },
        {
          text: 'Contratado', value: 'total', align: 'end', sortable: false,
        },
        // {
        //   text: 'Anticipo', value: 'totalAnticipo', align: 'end', sortable: false,
        // },
        // {
        //   text: 'Supr. Externa', value: 'supervisionExterna', sortable: true,
        // },
        {
          text: 'F. Inicio', value: 'fechaInicio', align: 'center', sortable: false,
        },
        {
          text: 'F. Término', value: 'fechaTermino', align: 'center', sortable: false,
        },
        {
          text: 'Av. Prog.', value: 'avanceProgramado', align: 'center', sortable: false,
        },
        {
          text: 'Av. Fisico', value: 'avanceFisico', align: 'center', sortable: false,
        },
        {
          text: 'Av. Finan.', value: 'avanceFinanciero', align: 'center', sortable: false,
        },
        // {
        //   text: 'Atraso', value: 'estatus', align: 'center', sortable: true,
        // },
      ],
    };
  },
  methods: {
    getImagenAlbum(idContrato) {
      const activdades = this.getActividadesTodas
        .filter((actividad) => actividad.idContrato === idContrato)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      if (!activdades) return null;
      let imagen = null;
      activdades.forEach((actividad) => {
        if (imagen) return;
        if (actividad.imagenes.length < 1) return;
        [imagen] = actividad.imagenes;
      });
      return imagen;
    },
    colorEstatus(avanceDiferencia) {
      if (avanceDiferencia <= 5) return 'success';
      if (avanceDiferencia > 5 && avanceDiferencia <= 25) return 'yellow darken-2';
      if (avanceDiferencia > 25) return 'red darken-2';
      return 'success';
    },
    dosDigitos(num, decimals) {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: decimals || 2,
        maximumFractionDigits: decimals || 2,
      });
    },
  },
  computed: {
    getActividadesTodas() {
      if (!this.contratoActividadesTodas) return [];
      return this.contratoActividadesTodas
        .filter((actividad) => actividad.tipo === 3)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
